import {
  getPersistedState,
  LocalStorageStates,
  saveState
} from '@/helpers/localStorageHelper';
import { model } from '@arkas/core';
import store from '@/store';

// to persist the app state in the local storage.
// when the redux state changes, local storage saves it too.
store.subscribe(() => {
  saveState('app.state', {
    appModel: store.getState().appModel
  });
});

export interface AppStateModelDto {
  random: number;
  currentCustomerTab: string;
  isSmallScreen: boolean;
  topMenu: boolean;
  darkTheme: boolean;
  collapseSider: boolean;
}

// Local Storage'dan initial state alınıyor.
const persistedState: string | null = getPersistedState(
  LocalStorageStates.appState
);
const appState = persistedState
  ? JSON.parse(persistedState).appModel
  : undefined;

const initialState: AppStateModelDto = {
  random: 0,
  currentCustomerTab: appState ? appState.currentCustomerTab : '1',
  isSmallScreen: false,
  topMenu: false,
  darkTheme: appState ? appState.darkTheme : false,
  collapseSider: appState ? appState.collapseSider : false
};

export default model({
  config: {
    name: 'appModel',
    initialState
  },
  reducers: {
    setCollapseSider(state, collapseSider: boolean) {
      return { ...state, collapseSider };
    },
    setDeviceSize(state, isSmallScreen: boolean) {
      return { ...state, isSmallScreen };
    },
    setTopMenu(state, topMenu) {
      return { ...state, topMenu };
    },
    setDarkTheme(state, darkTheme) {
      return { ...state, darkTheme };
    },
    setRandom(state, random) {
      return { ...state, random };
    },
    setCurrentCustomerTab(state, currentCustomerTab) {
      return { ...state, currentCustomerTab };
    }
  }
});
